import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StateTypeDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CountryApiClient extends BaseCRUDApiClient<StateTypeDtoModel> {
  baseUrl = this.config.apiEndpoint + '/state-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
